<template>
  <v-app>
    <v-main >
      <router-view />
    </v-main>
    <!-- <v-footer>
      <v-container  class="grey--text text-center">
        <v-row no-gutters>
        <v-col cols="12" sm="4" md="2" >
          
        </v-col>
        <v-col cols="12" sm="4" md="2" >
          {{ new Date().getFullYear() }} — Powered by: <a class="footer-link" href=""> 
             Press Media</a>
        </v-col>
        <v-col cols="12" sm="4" md="2" >
          {{ new Date().getFullYear() }} — Powered by: <a class="footer-link" href=""> 
             Press Media</a>
        </v-col>
        </v-row>
      </v-container>
      </v-footer> -->
       <v-footer
    dark
    padless
  >
    <v-card
      flat
      tile
      class="indigo lighten-1 white--text text-center"
      width="100%"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-4 white--text"
          icon
        >
          <v-icon size="24px">
            {{ icon }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        <strong>Regd. Office:</strong> S-III-21, L.B. Stadium, Hyderabad. 
        <strong>Head Office:</strong> Door#2, Sec. Floor, Reliable Business Centre, Troop Bazar, Bank Street, Abids, Hyderabad (T.S.) India. 
        <strong>Central Office:</strong> 1/19, Regal Building, Cannaught Place, Behind Regal Cinema, New Delhi-1.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — Powered by: <router-link class="footer-link" to="/"> 
             Press Media</router-link>
      </v-card-text>
    </v-card>
  </v-footer>
  </v-app>
</template>

<script>


export default {
  name: 'App',
  components: {
  },

  data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram',
      ],
  }),

  methods:{
    
  }
};
</script>
<style scoped>
body{
  --secondary-color: #fff;
}
#app{
  background-color: #4D4C5F;
}
.footer-link{
  text-decoration: none;
  color: #fff;
  font-weight: 500;
}
</style>
